var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCareers(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.240234,
    y: 0.647461,
    width: 41.6947,
    height: 41.6947,
    rx: 11.8004,
    fill: "#DDEBFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.4493 12.1528C17.9105 12.1528 16.6631 13.4003 16.6631 14.939V15.021C16.6631 15.4736 16.2962 15.8405 15.8436 15.8405H14.3403C13.1418 15.8405 12.1309 16.7329 11.9822 17.9222L11.5185 21.6318C11.3718 22.8053 12.1104 23.9081 13.2513 24.2193L20.0317 26.0685C20.7234 26.2571 21.453 26.2571 22.1447 26.0685L28.9251 24.2193C30.0661 23.9081 30.8046 22.8053 30.6579 21.6318L30.1942 17.9222C30.0456 16.7329 29.0346 15.8405 27.8361 15.8405H26.3328C25.8803 15.8405 25.5134 15.4736 25.5134 15.021V14.939C25.5134 13.4003 24.2659 12.1528 22.7272 12.1528H19.4493ZM23.2188 15.8405C23.6714 15.8405 24.0383 15.4736 24.0383 15.021V14.939C24.0383 14.2149 23.4513 13.6279 22.7272 13.6279H19.4493C18.7251 13.6279 18.1381 14.2149 18.1381 14.939V15.021C18.1381 15.4736 18.505 15.8405 18.9576 15.8405H23.2188ZM17.4006 17.3155H14.3403C13.8857 17.3155 13.5023 17.654 13.4459 18.1051L12.9822 21.8148C12.9265 22.2599 13.2067 22.6782 13.6395 22.7962L20.4198 24.6454C20.8574 24.7648 21.319 24.7648 21.7566 24.6454L28.537 22.7962C28.9698 22.6782 29.2499 22.2599 29.1943 21.8148L28.7306 18.1051C28.6742 17.654 28.2907 17.3155 27.8361 17.3155H24.7758H17.4006Z",
    fill: "#2F80ED"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8926 23.5435V27.6895C12.8926 28.7941 13.788 29.6895 14.8926 29.6895H27.282C28.3866 29.6895 29.282 28.7941 29.282 27.6895V23.5435",
    stroke: "#2F80ED",
    strokeWidth: 1.47505,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareers);
export default __webpack_public_path__ + "static/media/careers.d0e55766017d4d7cb014e5f9a9102c75.svg";
export { ForwardRef as ReactComponent };